/* globals MicroModal */

export default class PopupVideoModal {
  constructor() {
    this.$button = document.querySelector('.homepageHeroPopupVideoButton');
    this.$video = document.querySelector('.homepageHeroPopupVideo');

    this.onClick = this.onClick.bind(this);
    this.$button.addEventListener('click', this.onClick);
  }

  onClick() {
    MicroModal.show('homepagePopupVideoModal', {
      awaitCloseAnimation: true,
      disableScroll: true,
      onClose: () => {
        this.$video.pause();
      },
      onShow: () => {
        this.$video.play();
      },
    });
  }

  unmount() {
    this.$video.pause();
    this.$button.removeEventListener('click', this.onClick);
  }
}
